window.addEventListener('load', function() {

  var deleteAlertButtons = document.querySelectorAll('.js-delete_alert');
  deleteAlertButtons.forEach((deleteAlertButton) => {

    deleteAlertButton.addEventListener('click', function(){

      let currentLi = document.querySelector('.js-alert-item-' + deleteAlertButton.dataset.id);
      let currentClosingModal = deleteAlertButton.nextElementSibling;

      // Delete alert
      xhr = new XMLHttpRequest();
      loadPostsAjaxUrl = ajax_js.ajaxurl + '?action=remove_alert&id=' + deleteAlertButton.dataset.id;
      xhr.open('GET', loadPostsAjaxUrl);
      xhr.send();

      currentClosingModal.click();
      currentLi.remove();

    });

  });

});
